export default __webpack_public_path__ + "static/media/62t.408d8850.jpg";